import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Sidebar from "./Sidebar";
import { ProducerCodeSideBar } from "./ProducerCodeSideBar";
import { NewspaperIcon, QrCodeIcon } from "@heroicons/react/24/solid";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
const ProducerCodeReports = () => {
  const userPermissions = useRecoilValue(permissionsSelector);
  const carrierstates =
    PERMISSIONS.permission_report_carrierstatesofficecode_view;
  const cdrc = PERMISSIONS.permission_report_cdrcexception_view;
  return (
    <div className="p-4  min-h-fit">
      {(userPermissions.includes(carrierstates) ||
        userPermissions.includes(cdrc)) && (
        <>
          <div>
            <div className="pl-4 flex gap-2 items-center">
              <div>
                <QrCodeIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
              </div>
              <div className="flex flex-col leading tight">
                <h3 className="text-xs font-medium text-gray-500">
                  Reports Module
                </h3>
                <h1 className="mr-auto font-bold text-primary text-md uppercase">
                  PRODUCER CODE REPORTS
                </h1>
              </div>
            </div>
          </div>
          <div className="bg-white flex flex-row h-full ">
            <Router>
              <div
                className="w-1/5 h-full flex sm:w-auto overflow-y-auto flex-col flex-grow
             ml-4 bg-white mt-4 -mr-px z-10"
              >
                <Sidebar />
              </div>

              <div
                className={
                  "w-4/5 bg-white table-shadow overflow-y-auto  mt-4 mr-4"
                }
              >
                {ProducerCodeSideBar.map((main) => {
                  return (
                    <Switch key={main.title}>
                      <Route
                        index
                        path={main.to}
                        exact
                        component={main.component}
                      />
                      {/* <Redirect exact from="/" to={sub.path} /> */}
                    </Switch>
                  );
                })}
              </div>
            </Router>
          </div>
        </>
      )}
    </div>
  );
};
export default ProducerCodeReports;
